Promise.all([import(/* webpackMode: "eager" */ './header.scss'), import('../mobile-menu/mobile-menu')]).then(() => {
  $('.widget.header').each(function (i, el) {
    $(el).data('widget', new Header(el))
    $(el).data('widget').init()
  })
})

function Header(el) {
  const self = this
  self.el = $(el)

  self.menuButton = self.el.find('.menu-button')

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Header init', self)
    }

    self.menuButton.click(function (e) {
      e.preventDefault()
      $('body').toggleClass('show-mobile-menu')
      if ($('body').hasClass('show-mobile-menu')) {
        $('.widget.mobile-menu').css('z-index', '8999');
      }
      else {
        $('.widget.mobile-menu').css('z-index', '1');
      }   
    })
  }
}
